import { Injectable } from '@angular/core';
import { FirestoreSubCollectionRepository } from '@core/services';
import { EngineFormItem } from '@models/client-portal/engine-client-intake';

export interface ClientIntakeFormItemsPathParams {
	businessId: string;
	matterId: string;
	clientIntakeFormId: string;
}

@Injectable({
	providedIn: 'root',
})
export class ClientIntakeFormItemsSubCollectionRepo extends FirestoreSubCollectionRepository<
	EngineFormItem & { id?: string },
	ClientIntakeFormItemsPathParams
> {
	protected getCollectionPath(params: ClientIntakeFormItemsPathParams): string {
		return `businesses/${params.businessId}/matters/${params.matterId}/clientIntakeForms/${params.clientIntakeFormId}/intakeFormItems`;
	}
}
